jQuery(document).ready(function($) {
	$("#galeria .items")
		.slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			dots: false,
			prevArrow:
				'<a class="slick-arrow slick-arrow-prev" href="javascript:void(null);">&leftarrow;</a>',
			nextArrow:
				'<a class="slick-arrow slick-arrow-next" href="javascript:void(null);">&rightarrow;</a>',
		})
		.on("afterChange", function(event, slick, num) {
			const $current = $("#galeria .slick-current .imagen");
			const $titulo = $("#galeria .inferior-in");
			const titulo = $current.find("img").attr("alt");
			$titulo.html(titulo);
		});
});
